import React from 'react';
import { Checkbox as ChakraCheckbox, CheckboxProps, Text, Link } from '@chakra-ui/react';

interface MyCheckboxProps extends CheckboxProps {
  label?: string;
  labelWithLink?: {
    link: string;
    text: string;
  };
  error?: boolean;
}

export const CheckboxCustom: React.FC<MyCheckboxProps> = ({
  label,
  labelWithLink,
  error,
  ...rest
}) => {
  return (
    <ChakraCheckbox
      _checked={{
        '& .chakra-checkbox__control': {
          background: '#000 !important',
          borderColor: '#000 !important',
        },
      }}
      _hover={{
        background: 'transparent',
      }}
      iconSize="13px"
      iconColor="#fff"
      {...rest}
    >
      {label && (
        <Text color={error ? '#E53E3E' : '#222'} fontSize="12px">
          {label}{' '}
          {labelWithLink && (
            <Link textDecor="underline" href={labelWithLink.link}>
              {labelWithLink.text}
            </Link>
          )}
        </Text>
      )}
    </ChakraCheckbox>
  );
};
